import React from 'react'
import FormLogin from '../components/organisms/FormLogin'

function Login() {
  return <FormLogin />
}

export default Login
